<script setup>
const controlPlaneComponents = [
  {
    name: 'API Server (kube-apiserver)',
    status: 'Running',
    description: 'Entry point for cluster management, handles REST API requests and cluster state',
    health: 'Healthy'
  },
  {
    name: 'Scheduler (kube-scheduler)',
    status: 'Running',
    description: 'Assigns pods to worker nodes based on resources and constraints',
    health: 'Healthy'
  },
  {
    name: 'Controller Manager',
    status: 'Running',
    description: 'Manages node status, replication, endpoints, and service accounts',
    health: 'Healthy'
  },
  {
    name: 'etcd',
    status: 'Running',
    description: 'Distributed key-value store for cluster state and configuration',
    health: 'Healthy'
  },
  {
    name: 'Cloud Controller Manager',
    status: 'Running',
    description: 'Manages cloud provider interactions (load balancers, storage, etc.)',
    health: 'Healthy'
  }
]
</script>

<template>
  <div class="p-4">
    <h1 class="text-2xl font-bold mb-6">Kubernetes Management</h1>
    
    <div class="grid gap-6">
      <!-- Control Plane Components -->
      <div class="bg-white p-6 rounded-lg shadow">
        <h2 class="text-lg font-semibold mb-4">Control Plane Components</h2>
        <div class="space-y-4">
          <div v-for="component in controlPlaneComponents" 
               :key="component.name"
               class="border rounded-lg p-4">
            <div class="flex items-center justify-between">
              <div>
                <h3 class="font-medium">{{ component.name }}</h3>
                <p class="text-sm text-gray-600 mt-1">{{ component.description }}</p>
              </div>
              <div class="flex items-center gap-3">
                <span class="px-2 py-1 text-sm rounded-full bg-green-100 text-green-800">
                  {{ component.status }}
                </span>
                <button class="text-gray-500 hover:text-gray-700">
                  <i class="fas fa-ellipsis-v"></i>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Cluster Overview -->
      <div class="bg-white p-6 rounded-lg shadow">
        <h2 class="text-lg font-semibold mb-4">Cluster Overview</h2>
        <div class="grid grid-cols-3 gap-4">
          <div class="p-4 bg-gray-50 rounded">
            <h3 class="font-medium mb-2">Nodes</h3>
            <p class="text-2xl">3/3</p>
            <p class="text-sm text-gray-600">Active</p>
          </div>
          <div class="p-4 bg-gray-50 rounded">
            <h3 class="font-medium mb-2">Pods</h3>
            <p class="text-2xl">12/12</p>
            <p class="text-sm text-gray-600">Running</p>
          </div>
          <div class="p-4 bg-gray-50 rounded">
            <h3 class="font-medium mb-2">Services</h3>
            <p class="text-2xl">8</p>
            <p class="text-sm text-gray-600">Active</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template> 